(() => {
  const V = window.veloria || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // ---------- argent
  function money(cents) {
    const fmt = String(V.moneyFormat || "{{amount_with_comma_separator}}€").replace(/<[^>]*>/g, "");
    const n = (cents / 100);
    const two = n.toFixed(2);
    const thou = (s, sep) => s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      switch (k) {
        case "amount_no_decimals": return thou(String(Math.round(n)), ",");
        case "amount_with_comma_separator": { const [i, d] = two.split("."); return thou(i, ".") + "," + d; }
        case "amount_no_decimals_with_comma_separator": return thou(String(Math.round(n)), ".");
        case "amount_with_space_separator": { const [i, d] = two.split("."); return thou(i, " ") + "," + d; }
        default: { const [i, d] = two.split("."); return thou(i, ",") + "." + d; }
      }
    });
  }
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const sized = (url, w) => url ? url + (url.includes("?") ? "&" : "?") + "width=" + w : "";

  // ---------- toast
  let tt;
  function toast(msg) {
    const el = $("[data-toast]"); if (!el) return;
    el.textContent = msg; el.hidden = false;
    clearTimeout(tt); tt = setTimeout(() => (el.hidden = true), 2600);
  }

  // ---------- bandeau
  const msgs = $$(".announce-msg");
  if (msgs.length > 1 && !matchMedia("(prefers-reduced-motion: reduce)").matches) {
    let i = 0;
    setInterval(() => { msgs[i].classList.remove("is-active"); i = (i + 1) % msgs.length; msgs[i].classList.add("is-active"); }, 4500);
  }

  // ---------- menu mobile
  const nav = $("[data-nav]"), mb = $("[data-menu-toggle]");
  if (nav && mb) mb.addEventListener("click", () => { const o = nav.classList.toggle("open"); mb.setAttribute("aria-expanded", o); });

  // ---------- tri collection
  const sort = $("[data-sort]");
  if (sort) sort.addEventListener("change", () => { const u = new URL(location.href); u.searchParams.set("sort_by", sort.value); u.searchParams.delete("page"); location.href = u.toString(); });

  // ---------- galerie produit
  const mainImg = $(".g-main img");
  $$("[data-thumb]").forEach(b => b.addEventListener("click", () => {
    if (!mainImg) return;
    mainImg.removeAttribute("srcset"); mainImg.src = b.dataset.thumb;
    $$("[data-thumb]").forEach(x => x.classList.toggle("is-active", x === b));
  }));

  // ---------- variantes
  $$("[data-product]").forEach(root => {
    const priceEl = $("[data-price]", root), x3 = $("[data-x3]", root), btn = $("[data-add-btn]", root);
    $$('input[type=radio][name=id]', root).forEach(r => r.addEventListener("change", () => {
      if (priceEl) priceEl.innerHTML = r.dataset.compare ? `<s>${r.dataset.compare}</s> <b>${r.dataset.price}</b>` : r.dataset.price;
      if (x3) x3.textContent = `ou 3 x ${r.dataset.third} sans frais`;
      const ok = r.dataset.available === "true";
      if (btn) { btn.disabled = !ok; btn.textContent = ok ? "Ajouter au panier" : "Épuisé"; }
      const u = new URL(location.href); u.searchParams.set("variant", r.value); history.replaceState(null, "", u);
    }));
    $$("[data-qty-step]", root).forEach(b => b.addEventListener("click", () => {
      const inp = b.parentElement.querySelector("input");
      inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
    }));
  });

  // ---------- panier
  const drawer = $("[data-cart-drawer]"), scrim = $("[data-cart-scrim]");
  const onCartPage = location.pathname.replace(/\/$/, "").endsWith("/cart");
  let lastFocus = null;
  function openCart() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add("open"); drawer.setAttribute("aria-hidden", "false"); scrim.hidden = false; document.body.classList.add("lock");
    $("[data-cart-close]", drawer)?.focus();
  }
  function closeCart() {
    if (!drawer || !drawer.classList.contains("open")) return;
    drawer.classList.remove("open"); drawer.setAttribute("aria-hidden", "true"); scrim.hidden = true; document.body.classList.remove("lock");
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  let lastCount = 0;
  async function getCart() {
    const r = await fetch(V.routes.cart + ".js?t=" + Date.now(), { credentials: "same-origin", cache: "no-store", headers: { Accept: "application/json" } });
    if (!r.ok) throw new Error("cart " + r.status);
    return r.json();
  }
  async function refresh() { const c = await getCart(); render(c); return c; }

  const ICON_TRASH = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg>';

  function lineHTML(it, i) {
    const name = esc(it.product_title.split(" – ")[0]);
    const sub = it.product_title.split(" – ")[1];
    const vt = it.variant_title && it.variant_title !== "Default Title" && !it.product_has_only_default_variant ? `<span class="muted">${esc(it.variant_title)}</span>` : (sub ? `<span class="muted">${esc(sub)}</span>` : "");
    const img = it.image ? `<img src="${esc(sized(it.image, 240))}" alt="" loading="lazy">` : "";
    const compare = it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price)}</s>` : "";
    return `<div class="item" data-item="${i + 1}">
      <a class="mini" href="${esc(it.url)}">${img}</a>
      <div class="meta">
        <a class="pname" href="${esc(it.url)}">${name}</a>${vt}
        <span class="unit muted">${money(it.final_price)} l'unité</span>
        <div class="qtyline">
          <button type="button" data-line="${i + 1}" data-qty="${it.quantity - 1}" aria-label="Retirer un">−</button>
          <span aria-live="polite">${it.quantity}</span>
          <button type="button" data-line="${i + 1}" data-qty="${it.quantity + 1}" aria-label="Ajouter un">+</button>
        </div>
      </div>
      <div class="lend">
        <span class="price">${compare}${money(it.final_line_price)}</span>
        <button type="button" class="rm" data-line="${i + 1}" data-qty="0" aria-label="Supprimer ${name}">${ICON_TRASH}</button>
      </div>
    </div>`;
  }

  function render(cart) {
    lastCount = cart.item_count;
    $$("[data-cart-count]").forEach(el => { el.textContent = cart.item_count; el.classList.remove("pop"); void el.offsetWidth; el.classList.add("pop"); });
    $$("[data-cart-count-label]").forEach(el => { el.textContent = cart.item_count ? `(${cart.item_count})` : ""; });
    if (drawer) drawer.classList.toggle("is-empty", !cart.item_count);
    const list = $("[data-cart-items]");
    if (list) {
      if (cart.items.length) list.innerHTML = cart.items.map(lineHTML).join("");
      else { const tpl = $("[data-empty-tpl]"); list.innerHTML = tpl ? tpl.innerHTML : `<div class="empty"><p>Votre panier est vide.</p></div>`; }
    }
    const sub = $("[data-cart-subtotal]"); if (sub) sub.textContent = money(cart.total_price);
    const x3 = $("[data-cart-x3]"); if (x3) x3.textContent = cart.total_price ? `ou 3 x ${money(Math.round(cart.total_price / 3))} sans frais` : "";
    const co = $("[data-checkout]"); if (co) co.disabled = !cart.item_count;
    const t = V.freeShipping || 0, st = $("[data-ship-text]"), sb = $("[data-ship-bar]"), sh = $("[data-ship]");
    if (t > 0 && st && sb) {
      // Seuil appliqué aux bijoux & coffrets seulement : rangement, luminaires et déco sont déjà livrés gratuitement
      const home = V.homeTypes || [];
      const jewel = cart.items.filter(it => !home.includes(it.product_type));
      const base = jewel.reduce((s, it) => s + it.final_line_price, 0);
      const left = jewel.length ? t - base : 0;
      st.innerHTML = !cart.item_count ? `Livraison offerte dès <b>${money(t)}</b> de bijoux`
        : !jewel.length ? "Livraison offerte sur votre commande ✓"
        : left > 0 ? `Plus que <b>${money(left)}</b> de bijoux pour la livraison offerte` : "Bravo, la livraison vous est offerte ✓";
      sb.style.width = (!cart.item_count ? 0 : !jewel.length ? 100 : Math.min(100, (base / t) * 100)) + "%";
      if (sh) sh.classList.toggle("done", cart.item_count > 0 && left <= 0);
    }
    upsell(cart);
  }

  // Suggestions « Complétez votre cadeau » (recommandations Shopify)
  let upFor = null;
  async function upsell(cart) {
    const box = $("[data-upsell]"), lst = $("[data-upsell-list]");
    if (!box || !lst || !V.routes.recommendations) return;
    if (!cart.items.length) { box.hidden = true; upFor = null; return; }
    const pid = cart.items[0].product_id;
    const inCart = new Set(cart.items.map(i => i.product_id));
    if (upFor === pid && lst.children.length) {
      $$("[data-up-pid]", lst).forEach(el => el.hidden = inCart.has(+el.dataset.upPid));
      box.hidden = !$$("[data-up-pid]:not([hidden])", lst).length;
      return;
    }
    upFor = pid;
    try {
      const r = await fetch(`${V.routes.recommendations}.json?product_id=${pid}&limit=6`, { headers: { Accept: "application/json" } });
      if (!r.ok) throw 0;
      const j = await r.json();
      const prods = (j.products || []).filter(p => p.available && !inCart.has(p.id)).slice(0, 3);
      if (!prods.length) { box.hidden = true; return; }
      lst.innerHTML = prods.map(p => {
        const v = (p.variants || []).find(x => x.available) || p.variants[0];
        const one = p.variants.length === 1;
        const img = p.featured_image ? `<img src="${esc(sized(p.featured_image, 200))}" alt="" loading="lazy">` : "";
        const action = one
          ? `<form method="post" action="${esc(V.routes.add)}" data-ajax-add class="up-form"><input type="hidden" name="id" value="${v.id}"><input type="hidden" name="quantity" value="1"><button type="submit" class="up-add" aria-label="Ajouter ${esc(p.title)}">+</button></form>`
          : `<a class="up-add" href="${esc(p.url)}" aria-label="Choisir une option pour ${esc(p.title)}">→</a>`;
        return `<div class="up-card" data-up-pid="${p.id}">
          <a class="up-img" href="${esc(p.url)}">${img}</a>
          <a class="up-name" href="${esc(p.url)}">${esc(p.title.split(" – ")[0])}</a>
          <span class="up-price">${money(p.price)}</span>${action}</div>`;
      }).join("");
      box.hidden = false;
    } catch (_) { box.hidden = true; }
  }

  async function change(line, quantity) {
    const row = $(`[data-item="${line}"]`);
    if (row) row.classList.add(quantity === 0 ? "removing" : "busy");
    const r = await fetch(V.routes.change + ".js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ line, quantity }) });
    if (r.ok) {
      const cart = await r.json();
      if (onCartPage && !drawer?.classList.contains("open")) { location.reload(); return; }
      setTimeout(() => render(cart), quantity === 0 ? 260 : 0);
    } else { if (row) row.classList.remove("busy", "removing"); toast("Quantité indisponible"); }
  }

  document.addEventListener("click", e => {
    const op = e.target.closest("[data-cart-open]");
    if (op && drawer && !onCartPage) { e.preventDefault(); openCart(); refresh(); return; }
    if (e.target.closest("[data-cart-close]") || e.target === scrim) { e.preventDefault?.(); closeCart(); return; }
    const ln = e.target.closest("[data-line]");
    if (ln) { e.preventDefault(); change(+ln.dataset.line, +ln.dataset.qty); }
  });
  document.addEventListener("keydown", e => { if (e.key === "Escape") closeCart(); });

  // Mot pour un cadeau : enregistré automatiquement
  const note = $("[data-cart-note]"), noteStatus = $("[data-note-status]");
  if (note && V.routes.update) {
    let nt;
    const save = async () => {
      try {
        const r = await fetch(V.routes.update + ".js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ note: note.value }) });
        if (noteStatus) noteStatus.textContent = r.ok ? "Message enregistré ✓" : "";
      } catch (_) {}
    };
    note.addEventListener("input", () => { if (noteStatus) noteStatus.textContent = ""; clearTimeout(nt); nt = setTimeout(save, 700); });
    note.addEventListener("blur", () => { clearTimeout(nt); save(); });
  }

  // Ajout au panier : AJAX, avec repli sur l'envoi classique du formulaire
  // (redirection vers /cart) dès que quelque chose ne se passe pas comme prévu.
  function nativeSubmit(f) { f.removeAttribute("data-ajax-add"); HTMLFormElement.prototype.submit.call(f); }
  document.addEventListener("submit", async e => {
    const f = e.target.closest("form[data-ajax-add]"); if (!f) return;
    if (!window.fetch || !window.FormData) return; // envoi classique
    e.preventDefault();
    const b = f.querySelector("[type=submit]") || (f.id && $(`[form="${f.id}"]`)); const label = b ? b.textContent : "";
    const err = f.querySelector("[data-add-error]"); if (err) err.hidden = true;
    if (b) { b.disabled = true; if (!b.classList.contains("up-add")) b.textContent = "Ajout…"; }
    const before = lastCount;
    let ok = false;
    try {
      const r = await fetch(V.routes.add + ".js", { method: "POST", credentials: "same-origin", headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" }, body: new FormData(f) });
      let j = {};
      try { j = await r.json(); } catch (_) {}
      if (r.status === 422) {
        const msg = j.description || j.message || "Ce produit n'est plus disponible dans cette quantité.";
        if (err) { err.textContent = msg; err.hidden = false; } toast(msg);
        return;
      }
      if (!r.ok) throw new Error("add " + r.status);
      let cart;
      try { cart = await refresh(); } catch (_) { location.href = V.routes.cart; return; }
      if (cart.item_count <= before) throw new Error("panier non mis à jour");
      ok = true;
      if (b && !b.classList.contains("up-add")) b.textContent = "Ajouté ✓";
      if (onCartPage) location.reload(); else openCart();
    } catch (ex) {
      nativeSubmit(f);
      return;
    } finally {
      if (b) { setTimeout(() => { b.disabled = false; if (!b.classList.contains("up-add")) b.textContent = label; }, ok ? 1400 : 0); }
    }
  });

  if (drawer) refresh().catch(() => {});
})();
